export enum NumberPagesEnum {
  Landing = 1,
  Cart = 2,
  Pages = 3,
  History = 4,
  Menu = 5,
}
